import { axiosInstance } from "../services/AxiosInstance";

const API_URL = "/students";

export const getAllStudents = async (
  page = 1,
  limit = 10,
  searchTerm = "",
  searchField = "",
  startDate = "",
  endDate = "",
  /* receiptStatus=true was hard-coded into the URL, so every caller of this
     function could only ever see students who have a receipt. That is right
     for the billing screens this was written for and wrong for anything that
     just wants to find a person -- the topbar search could not turn up a
     student without a receipt, by name or by email, and looked broken.
     Callers that want the whole roster pass false. */
  receiptStatusOnly = true
) => {
  try {
    let url = `${API_URL}?page=${page}&limit=${limit}`;
    if (receiptStatusOnly) {
      url += `&receiptStatus=true`;
    }

    // ✅ Add date filters if provided
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }

    // ✅ search param (not searchTerm)
    if (searchTerm && searchTerm.trim() !== "") {
      url += `&search=${encodeURIComponent(searchTerm)}`;
      if (searchField && searchField !== "all") {
        url += `&searchField=${searchField}`;
      }
    }

    const response = await axiosInstance.get(url);

    const studentsData = response.data?.data || [];
    const pagination = response.data?.pagination || {
      total: 0,
      page,
      limit,
      totalPages: 0,
    };

    return { data: studentsData, pagination };
  } catch (error) {
    console.error("Error fetching students", error);
    throw error;
  }
};
/**
 * Switch a student active / inactive. Admin, superadmin and CRM only --
 * the API answers 403 to anyone else, because an inactive student is
 * locked out of the app. Resolves to { id, status, inactiveOn } and the
 * API's message; throws with the API's message on failure.
 */
export const setStudentStatus = async (studentId, status) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${studentId}/status`, { status });
    return { data: response.data?.data || null, message: response.data?.message || "" };
  } catch (error) {
    console.error("Error changing student status", error);
    const message = error?.response?.data?.message || "The status could not be changed";
    throw new Error(message);
  }
};
